export const minimumAspectRatio = 9 / 16; // Portrait phone
export const maximumAspectRatio = 10; // Generous min-height

export const isPanoramic = (ar: number) => {
  if (isNaN(ar)) return false;
  return ar >= maximumAspectRatio;
};

export const isPortrait = (ar: number) => {
  if (isNaN(ar)) return false;
  return ar <= minimumAspectRatio;
};

export const isNonConformingRatio = (ar: number) => {
  if (isNaN(ar)) return false;
  return !isPanoramic(ar) && !isPortrait(ar);
};

export const getAspectRatio = (width: number, height: number) => {
  if (!width || !height) {
    return "16 / 9";
  }
  const greatestCommonDivisor = (a: number, b: number): number =>
    b === 0 ? a : greatestCommonDivisor(b, a % b);

  const divisor = greatestCommonDivisor(width, height);
  const simplifiedWidth = Math.round(width / divisor);
  const simplifiedHeight = Math.round(height / divisor);

  return `${simplifiedWidth}/${simplifiedHeight}` as `${number}/${number}`;
};
